import { MultiLanguage } from "./MultiLanguage";

export interface IProcessConfigurationPersonnelType {
    id: string;
    title: MultiLanguage;
}

// El catálogo llega completo (incluidos los tipos ocultos) para poder mostrar el tipo ya guardado en un proceso.
export function findProcessConfigurationPersonnelType(processConfigurationPersonnelTypes: any[] | undefined, personnelTypeId: string): IProcessConfigurationPersonnelType | undefined {
    const foundPersonnelType = processConfigurationPersonnelTypes
        ? processConfigurationPersonnelTypes.find(personnelType => personnelType.id === personnelTypeId)
        : undefined;
    return foundPersonnelType ? { ...foundPersonnelType, title: new MultiLanguage(foundPersonnelType.title || {}) } : undefined;
}
